import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Typography } from '@mui/material'
import { DateTime } from 'luxon'
import CoachProfile from './CoachProfile'
import {
  CoachAvailabilityDay,
  CoachAvailabilityVideoCallSlot,
  CoachProfileWithVideoCallSlots,
} from '../useCoachAvailabilityDays'
import {
  CallBookingParticipantFragment,
  useCallDurationInMinutesQuery,
} from '../../videoCallBookingHeaderQueries.generated'

interface CoachProfileListProps {
  selectedDay: CoachAvailabilityDay
  selectedSlot: CoachAvailabilityVideoCallSlot | null
  onCallSlotPress: (slot: CoachAvailabilityVideoCallSlot | null) => void
  onCloseDialog: () => void
  participant: CallBookingParticipantFragment
}

const CoachProfileList = ({
  selectedDay,
  selectedSlot,
  onCallSlotPress,
  onCloseDialog,
  participant,
}: CoachProfileListProps) => {
  const styles = useStyles()
  const patientTimezone = participant.privateUserData?.timezone ?? 'America/Los_Angeles'

  const { data: callDurationData, loading: callDurationLoading } = useCallDurationInMinutesQuery({
    variables: { uid: participant.uid },
  })

  return (
    <div className={styles.container}>
      <Typography
        variant="body1"
        fontWeight="normal"
        sx={{
          padding: (theme) => theme.spacing(2, 4, 2, 4),
        }}
      >
        {callDurationLoading || !callDurationData?.callDurationInMinutes
          ? 'Book a video session on'
          : `Book a ${callDurationData.callDurationInMinutes}-min video session on`}
        &nbsp;
        <Typography variant="body1" fontWeight="600" component="span">
          {DateTime.fromISO(selectedDay.dayId, { zone: patientTimezone }).toFormat('LLL d (ZZZZ)')}
        </Typography>
      </Typography>

      {selectedDay.slots.map((coachWithSlots: CoachProfileWithVideoCallSlots) => (
        <CoachProfile
          coachWithSlots={coachWithSlots}
          key={coachWithSlots.coachProfile.id}
          selectedSlot={selectedSlot}
          setSelectedSlot={onCallSlotPress}
          onCloseDialog={onCloseDialog}
          participant={participant}
        />
      ))}
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export default CoachProfileList
